export function debounce (fn, delay) {
    let timeoutId = 0;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(...args), delay);
    };
}

export function throttle(fn, limit) {
    let throttling = false;
    return (...args) => {
        if (!throttling) {
            throttling = true;
            setTimeout(() => throttling = false, limit);
            return fn(...args);
        }
    };
}
